import {TextField} from '@mui/material'
import {FC, useState} from 'react'
import {CardItem} from './CardItem'
import {Tabs} from './Tabs'
const DashboardWrapper: FC = () => {
  // const [ipAddress, setIPAddress] = useState('')
  // useEffect(() => {
  //   fetch('https://api.ipify.org?format=json')
  //     .then((response) => response.json())
  //     .then((data) => setIPAddress(data.ip))
  //     .catch((error) => console.log(error))
  // }, [])

  const [activeTab, setActiveTab] = useState(0)
  const [keyword, setKeyword] = useState('')
  let connectedServices = [
    {
      id: 1,
      title: 'سامانه جامع پویا',
      link: 'http://puya.birjand.ac.ir/',
      icon: 'la-university',
    },
    {
      id: 2,
      title: 'سامانه 111',
      link: 'https://portal.111.ir/',
      icon: 'la-user-circle',
    },
  ]
  let profServices = [
    {
      id: 1,
      title: 'پرتال اطلاعات اساتید',
      link: 'https://cv.birjand.ac.ir/fa',
      icon: 'la-id-card',
    },
    {
      id: 2,
      title: 'سامانه جامع پویا',
      link: 'http://puya.birjand.ac.ir/',
      icon: 'la-university',
    },
    {
      id: 3,
      title: 'ایمیل دانشگاهی',
      link: 'http://mail.birjand.ac.ir/',
      icon: 'la-envelope',
    },
    {
      id: 4,
      title: 'خدمات امور بین الملل',
      link: 'https://birjand.ac.ir/isc/fa/page/3637',
      icon: 'la-globe',
    },
    {
      id: 5,
      title: 'رزرو سالن ها',
      link: 'https://birjand.ac.ir/fa/content/113/%D8%B1%D8%B2%D8%B1%D9%88-%D8%AA%D8%A7%D9%84%D8%A7%D8%B1%D9%87%D8%A7-%D9%88-%D8%B3%D8%A7%D9%84%D9%86-%D9%87%D8%A7%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF',
      icon: 'la-calendar-check',
    },
    {
      id: 6,
      title: 'سامانه نظام پیشنهادات',
      link: 'http://suggestion.birjand.ac.ir/',
      icon: 'la-lightbulb',
    },
    {
      id: 7,
      title: 'اتوماسیون اداری',
      link: 'https://oa.birjand.ac.ir:9001',
      icon: 'la-users',
    },
    // {
    //   id: 8,
    //   title: 'تور مجازی دانشگاه',
    //   link: 'http://vtour.birjand.ac.ir/',
    //   icon: 'la-map-marked-alt',
    // },
    {
      id: 9,
      title: 'سامانه جذب اساتید مدعو',
      link: 'http://jazb.birjand.ac.ir/',
      icon: 'la-chalkboard-teacher',
    },
    {
      id: 10,
      title: 'سامانه آموزش الکترونیکی',
      link: 'http://lms.birjand.ac.ir/',
      icon: 'la-desktop',
    },
    // {
    //   id: 11,
    //   title: 'سامانه پشتیبانی معاونت اداری و مالی',
    //   link: 'http://pmali.birjand.ac.ir/',
    //   icon: 'la-user-astronaut',
    // },
    {
      id: 12,
      title: 'اتوماسیون تغذیه',
      link: 'http://selfservice.birjand.ac.ir/',
      icon: 'la-utensils',
    },
    {
      id: 13,
      title: 'رابط حقوق شهروندی',
      link: 'http://birjand.ac.ir/fa/page/2300/%D8%B1%D8%A7%D8%A8%D8%B7-%D8%AD%D9%82%D9%88%D9%82-%D8%B4%D9%87%D8%B1%D9%88%D9%86%D8%AF%DB%8C',
      icon: 'la-hands-helping',
    },
    {
      id: 14,
      title: 'سند اخلاق حرفه ای اساتید دانشگاه',
      link: 'https://birjand.ac.ir/fa/page/3345',
      icon: 'la-file-alt',
    },
    {
      id: 15,
      title: 'نظامنامه اخلاق آموزشی',
      link: 'https://birjand.ac.ir/fa/page/4202',
      icon: 'la-file-contract',
    },
    {
      id: 16,
      title: 'مدیریت اشتراک اینترنت',
      link: 'https://sib.birjand.ac.ir/users/',
      icon: 'la-network-wired',
    },
    {
      id: 17,
      title: 'FTP(اینترنت داخلی)',
      link: 'https://webftp.birjand.ac.ir/?user=anonymous&password=anonymous',
      icon: 'la-cloud-download-alt',
    },
    {
      id: 18,
      title: 'راهنمای ساخت کانکشن اینترنت',
      link: 'https://birjand.ac.ir/ict/fa/page/2194/%D9%81%D8%B1%D8%A2%DB%8C%D9%86%D8%AF-%D9%86%D8%AD%D9%88%D9%87-%D8%A7%D8%AA%D8%B5%D8%A7%D9%84-%D8%A8%D9%87-%D8%A7%DB%8C%D9%86%D8%AA%D8%B1%D9%86%D8%AA',
      icon: 'la-wifi',
    },
    {
      id: 19,
      title: 'راهنمای تلفن دانشگاه',
      link: 'https://118.birjand.ac.ir/',
      icon: 'la-address-book',
    },
    {
      id: 20,
      title: 'تقویم اجرایی دانشگاه',
      link: 'https://birjand.ac.ir/fa/content/164/%D8%AA%D9%82%D9%88%DB%8C%D9%85-%D8%A7%D8%AC%D8%B1%D8%A7%DB%8C%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF-',
      icon: 'la-calendar',
    },
    {
      id: 21,
      title: 'کتابخانه مرکزی',
      link: 'https://birjand.ac.ir/lib/fa',
      icon: 'la-book-reader',
    },
    {
      id: 22,
      title: 'سامانه 111',
      link: 'https://portal.111.ir/',
      icon: 'la-user-circle',
    },
    {
      id: 23,
      title: 'تلویزیون اینترنتی',
      link: 'https://tv.birjand.ac.ir/',
      icon: 'la-tv',
    },
  ]
  let stuServices = [
    {
      id: 1,
      title: 'سامانه جامع پویا',
      link: 'http://puya.birjand.ac.ir/',
      icon: 'la-university',
    },
    {
      id: 2,
      title: 'سامانه ایمیل دانشگاهی',
      link: 'https://post.birjand.ac.ir/webmail/login/',
      icon: 'la-envelope',
    },
    {
      id: 3,
      title: 'اتوماسیون تغذیه',
      link: 'http://selfservice.birjand.ac.ir/',
      icon: 'la-utensils',
    },
    {
      id: 4,
      title: 'خدمات امور بین الملل (ویژه دانشجویان ایرانی)',
      link: 'https://birjand.ac.ir/isc/fa/page/4443/%D8%AE%D8%AF%D9%85%D8%A7%D8%AA-%D8%A7%D9%85%D9%88%D8%B1-%D8%A8%DB%8C%D9%86-%D8%A7%D9%84%D9%85%D9%84%D9%84-%D9%88%DB%8C%DA%98%D9%87-%D8%AF%D8%A7%D9%86%D8%B4%D8%AC%D9%88%DB%8C%D8%A7%D9%86-%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C-',
      icon: 'la-globe',
    },
    // {
    //   id: 5,
    //   title: 'تور مجازی دانشگاه',
    //   link: 'http://vtour.birjand.ac.ir/',
    //   icon: 'la-map-marked-alt',
    // },
    {
      id: 6,
      title: 'سامانه پذیرش دانشجویان تحصیلات تکمیلی',
      link: 'http://talent.birjand.ac.ir/start',
      icon: 'la-user-graduate',
    },
    {
      id: 7,
      title: 'درخواست غیرحضوری اخذ مدارک تحصیلی',
      link: 'https://birjand.postsam.ir/',
      icon: 'la-file-signature',
    },
    {
      id: 8,
      title: 'سامانه آموزش الکترونیکی',
      link: 'http://lms.birjand.ac.ir/',
      icon: 'la-desktop',
    },
    {
      id: 9,
      title: 'رابط حقوق شهروندی',
      link: 'http://birjand.ac.ir/fa/page/2300/%D8%B1%D8%A7%D8%A8%D8%B7-%D8%AD%D9%82%D9%88%D9%82-%D8%B4%D9%87%D8%B1%D9%88%D9%86%D8%AF%DB%8C',
      icon: 'la-hands-helping',
    },
    {
      id: 10,
      title: 'منشور حقوق دانشجویی',
      link: 'https://birjand.ac.ir/file/download/page/1544428261-1485590344-.pdf',
      icon: 'la-balance-scale',
    },
    {
      id: 11,
      title: 'ارتباط با نماینده وزیر در هیات نظارت دانشگاه بیرجند',
      link: 'http://birjand.ac.ir/fa/page/2350/%D9%86%D9%85%D8%A7%DB%8C%D9%86%D8%AF%D9%87-%D9%88%D8%B2%DB%8C%D8%B1-%D8%AF%D8%B1-%D9%87%DB%8C%D8%A7%D8%AA-%D9%86%D8%B8%D8%A7%D8%B1%D8%AA-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF',
      icon: 'la-phone-volume',
    },
    {
      id: 12,
      title: 'سامانه نظام پیشنهادات',
      link: 'http://suggestion.birjand.ac.ir/',
      icon: 'la-lightbulb',
    },
    {
      id: 13,
      title: 'انجمن دانش آموختگان',
      link: 'https://birjand.ac.ir/alumni/fa',
      icon: 'la-graduation-cap',
    },
    {
      id: 15,
      title: 'مدیریت اشتراک اینترنت',
      link: 'https://sib.birjand.ac.ir/users/',
      icon: 'la-network-wired',
    },
    {
      id: 16,
      title: 'FTP(اینترنت داخلی)',
      link: 'https://webftp.birjand.ac.ir/?user=anonymous&password=anonymous',
      icon: 'la-cloud-download-alt',
    },
    {
      id: 17,
      title: 'راهنمای ساخت کانکشن اینترنت',
      link: 'https://birjand.ac.ir/ict/fa/page/2194/%D9%81%D8%B1%D8%A2%DB%8C%D9%86%D8%AF-%D9%86%D8%AD%D9%88%D9%87-%D8%A7%D8%AA%D8%B5%D8%A7%D9%84-%D8%A8%D9%87-%D8%A7%DB%8C%D9%86%D8%AA%D8%B1%D9%86%D8%AA',
      icon: 'la-wifi',
    },
    {
      id: 18,
      title: 'راهنمای تلفن دانشگاه',
      link: 'https://118.birjand.ac.ir/',
      icon: 'la-address-book',
    },
    {
      id: 19,
      title: 'تقویم اجرایی دانشگاه',
      link: 'https://birjand.ac.ir/fa/content/164/%D8%AA%D9%82%D9%88%DB%8C%D9%85-%D8%A7%D8%AC%D8%B1%D8%A7%DB%8C%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF-',
      icon: 'la-calendar',
    },
    {
      id: 20,
      title: 'کتابخانه مرکزی',
      link: 'https://birjand.ac.ir/lib/fa',
      icon: 'la-book-reader',
    },
    {
      id: 21,
      title: 'سامانه 111',
      link: 'https://portal.111.ir/',
      icon: 'la-user-circle',
    },
    {
      id: 22,
      title: 'تلویزیون اینترنتی',
      link: 'https://tv.birjand.ac.ir/',
      icon: 'la-tv',
    },
  ]
  let otherStuServices = [
    {
      id: 1,
      title: 'خدمات دانشجویان بین الملل',
      link: 'http://birjand.ac.ir/isc/fa/page/3318',
      icon: 'la-globe',
    },
    {
      id: 2,
      title: 'رابط حقوق شهروندی',
      link: 'http://birjand.ac.ir/fa/page/2300/%D8%B1%D8%A7%D8%A8%D8%B7-%D8%AD%D9%82%D9%88%D9%82-%D8%B4%D9%87%D8%B1%D9%88%D9%86%D8%AF%DB%8C',
      icon: 'la-hands-helping',
    },
    // {
    //   id: 3,
    //   title: 'تور مجازی دانشگاه',
    //   link: 'http://vtour.birjand.ac.ir/',
    //   icon: 'la-map-marked-alt',
    // },
    {
      id: 4,
      title: 'مدیریت اشتراک اینترنت',
      link: 'https://sib.birjand.ac.ir/users/',
      icon: 'la-network-wired',
    },
    {
      id: 5,
      title: 'FTP(اینترنت داخلی)',
      link: 'https://webftp.birjand.ac.ir/?user=anonymous&password=anonymous',
      icon: 'la-cloud-download-alt',
    },
    {
      id: 6,
      title: 'راهنمای ساخت کانکشن اینترنت',
      link: 'https://birjand.ac.ir/ict/fa/page/2194/%D9%81%D8%B1%D8%A2%DB%8C%D9%86%D8%AF-%D9%86%D8%AD%D9%88%D9%87-%D8%A7%D8%AA%D8%B5%D8%A7%D9%84-%D8%A8%D9%87-%D8%A7%DB%8C%D9%86%D8%AA%D8%B1%D9%86%D8%AA',
      icon: 'la-wifi',
    },
    {
      id: 7,
      title: 'راهنمای تلفن دانشگاه',
      link: 'https://118.birjand.ac.ir/',
      icon: 'la-address-book',
    },
    {
      id: 8,
      title: 'تقویم اجرایی دانشگاه',
      link: 'https://birjand.ac.ir/fa/content/164/%D8%AA%D9%82%D9%88%DB%8C%D9%85-%D8%A7%D8%AC%D8%B1%D8%A7%DB%8C%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF-',
      icon: 'la-calendar',
    },
    {
      id: 9,
      title: 'کتابخانه مرکزی',
      link: 'https://birjand.ac.ir/lib/fa',
      icon: 'la-book-reader',
    },
    {
      id: 10,
      title: 'سامانه 111',
      link: 'https://portal.111.ir/',
      icon: 'la-user-circle',
    },
    {
      id: 11,
      title: 'تلویزیون اینترنتی',
      link: 'https://tv.birjand.ac.ir/',
      icon: 'la-tv',
    },
  ]
  let parentServices = [
    {
      id: 1,
      title: 'مرکز مشاوره',
      link: 'https://birjand.ac.ir/ccht/fa',
      icon: 'la-user-friends',
    },
    {
      id: 2,
      title: 'دانشکده ها',
      link: 'https://birjand.ac.ir/fa/page/1845/%D8%AF%D8%A7%D9%86%D8%B4%DA%A9%D8%AF%D9%87-%D9%87%D8%A7',
      icon: 'la-building',
    },
    {
      id: 3,
      title: 'ارتباط با معاون آموزشی',
      link: 'https://birjand.ac.ir/edu/fa/contactus',
      icon: 'la-phone-volume',
    },
    {
      id: 4,
      title: 'ارتباط با مدیر آموزشی',
      link: 'https://birjand.ac.ir/education/fa/page/707/%D9%85%D8%B3%D8%A6%D9%88%D9%84%DB%8C%D9%86',
      icon: 'la-phone-volume',
    },
    {
      id: 5,
      title: 'مرکز بهداشت',
      link: 'https://birjand.ac.ir/hct/fa',
      icon: 'la-heartbeat',
    },
    // {
    //   id: 6,
    //   title: 'تور مجازی',
    //   link: 'http://vtour.birjand.ac.ir/',
    //   icon: 'la-map-marked-alt',
    // },
    {
      id: 7,
      title: 'ارتباط با معاون دانشجویی',
      link: 'https://birjand.ac.ir/stu/fa/contactus',
      icon: 'la-phone-volume',
    },
    {
      id: 8,
      title: 'ارتباط با مدیر دانشجویی',
      link: 'https://birjand.ac.ir/mstudent/fa/page/1308/%D9%85%D8%B3%D8%A6%D9%88%D9%84%DB%8C%D9%86',
      icon: 'la-phone-volume',
    },
    {
      id: 9,
      title: 'رابط حقوق شهروندی',
      link: 'https://birjand.ac.ir/fa/page/2300/%D8%B1%D8%A7%D8%A8%D8%B7-%D8%AD%D9%82%D9%88%D9%82-%D8%B4%D9%87%D8%B1%D9%88%D9%86%D8%AF%DB%8C',
      icon: 'la-hands-helping',
    },
    {
      id: 10,
      title: 'ارتباط با روابط عمومی',
      link: 'https://birjand.ac.ir/prub/fa/page/2296/%D9%85%D8%AF%DB%8C%D8%B1-%D8%B1%D9%88%D8%A7%D8%A8%D8%B7-%D8%B9%D9%85%D9%88%D9%85%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF',
      icon: 'la-phone-volume',
    },
    {
      id: 11,
      title: 'ارتباط با رئیس دانشگاه',
      link: 'https://birjand.ac.ir/fa/contactus',
      icon: 'la-phone-volume',
    },
    {
      id: 12,
      title: 'مدیریت اشتراک اینترنت',
      link: 'https://sib.birjand.ac.ir/users/',
      icon: 'la-network-wired',
    },
    {
      id: 13,
      title: 'FTP(اینترنت داخلی)',
      link: 'https://webftp.birjand.ac.ir/?user=anonymous&password=anonymous',
      icon: 'la-cloud-download-alt',
    },
    {
      id: 14,
      title: 'راهنمای ساخت کانکشن اینترنت',
      link: 'https://birjand.ac.ir/ict/fa/page/2194/%D9%81%D8%B1%D8%A2%DB%8C%D9%86%D8%AF-%D9%86%D8%AD%D9%88%D9%87-%D8%A7%D8%AA%D8%B5%D8%A7%D9%84-%D8%A8%D9%87-%D8%A7%DB%8C%D9%86%D8%AA%D8%B1%D9%86%D8%AA',
      icon: 'la-wifi',
    },
    {
      id: 15,
      title: 'راهنمای تلفن دانشگاه',
      link: 'https://118.birjand.ac.ir/',
      icon: 'la-address-book',
    },
    {
      id: 16,
      title: 'تقویم اجرایی دانشگاه',
      link: 'https://birjand.ac.ir/fa/content/164/%D8%AA%D9%82%D9%88%DB%8C%D9%85-%D8%A7%D8%AC%D8%B1%D8%A7%DB%8C%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF-',
      icon: 'la-calendar',
    },
    {
      id: 17,
      title: 'کتابخانه مرکزی',
      link: 'https://birjand.ac.ir/lib/fa',
      icon: 'la-book-reader',
    },
    {
      id: 11,
      title: 'سامانه 111',
      link: 'https://portal.111.ir/',
      icon: 'la-user-circle',
    },
    {
      id: 12,
      title: 'تلویزیون اینترنتی',
      link: 'https://tv.birjand.ac.ir/',
      icon: 'la-tv',
    },
  ]
  let staffServices = [
    {
      id: 1,
      title: 'سامانه نظام پیشنهادات',
      link: 'http://suggestion.birjand.ac.ir/',
      icon: 'la-lightbulb',
    },
    {
      id: 2,
      title: 'اتوماسیون اداری',
      link: 'https://oa.birjand.ac.ir:9001',
      icon: 'la-users',
    },
    // {
    //   id: 3,
    //   title: 'تور مجازی دانشگاه',
    //   link: 'http://vtour.birjand.ac.ir/',
    //   icon: 'la-map-marked-alt',
    // },
    {
      id: 4,
      title: 'رابط حقوق شهروندی',
      link: 'http://birjand.ac.ir/fa/page/2300/%D8%B1%D8%A7%D8%A8%D8%B7-%D8%AD%D9%82%D9%88%D9%82-%D8%B4%D9%87%D8%B1%D9%88%D9%86%D8%AF%DB%8C',
      icon: 'la-hands-helping',
    },
    {
      id: 5,
      title: 'ایمیل دانشگاهی',
      link: 'http://mail.birjand.ac.ir/',
      icon: 'la-envelope',
    },
    {
      id: 6,
      title: 'سامانه جامع پویا',
      link: 'http://puya.birjand.ac.ir/gateway/PuyaAuthenticate.php',
      icon: 'la-university',
    },
    {
      id: 7,
      title: 'رزرو سالن ها',
      link: 'https://birjand.ac.ir/fa/content/113/%D8%B1%D8%B2%D8%B1%D9%88-%D8%AA%D8%A7%D9%84%D8%A7%D8%B1%D9%87%D8%A7-%D9%88-%D8%B3%D8%A7%D9%84%D9%86-%D9%87%D8%A7%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF',
      icon: 'la-calendar-check',
    },
    // {
    //   id: 8,
    //   title: 'سامانه ارزیابی عملکرد کارکنان',
    //   link: 'http://emp.birjand.ac.ir/logon.aspx',
    //   icon: 'la-user-check',
    // },
    {
      id: 9,
      title: 'سامانه هوشمند آیین نامه‌های دانشگاه بیرجند',
      link: 'http://soha.birjand.ac.ir/',
      icon: 'la-book',
    },
    {
      id: 10,
      title: 'سامانه تیکت پرتال جامع',
      link: 'http://ticket.birjand.ac.ir/login',
      icon: 'la-pen-square',
    },
    {
      id: 11,
      title: 'مدیریت اشتراک اینترنت',
      link: 'https://sib.birjand.ac.ir/users/',
      icon: 'la-network-wired',
    },
    {
      id: 12,
      title: 'FTP(اینترنت داخلی)',
      link: 'https://webftp.birjand.ac.ir/?user=anonymous&password=anonymous',
      icon: 'la-cloud-download-alt',
    },
    {
      id: 13,
      title: 'راهنمای ساخت کانکشن اینترنت',
      link: 'https://birjand.ac.ir/ict/fa/page/2194/%D9%81%D8%B1%D8%A2%DB%8C%D9%86%D8%AF-%D9%86%D8%AD%D9%88%D9%87-%D8%A7%D8%AA%D8%B5%D8%A7%D9%84-%D8%A8%D9%87-%D8%A7%DB%8C%D9%86%D8%AA%D8%B1%D9%86%D8%AA',
      icon: 'la-wifi',
    },
    {
      id: 14,
      title: 'راهنمای تلفن دانشگاه',
      link: 'https://118.birjand.ac.ir/',
      icon: 'la-address-book',
    },
    {
      id: 15,
      title: 'تقویم اجرایی دانشگاه',
      link: 'https://birjand.ac.ir/fa/content/164/%D8%AA%D9%82%D9%88%DB%8C%D9%85-%D8%A7%D8%AC%D8%B1%D8%A7%DB%8C%DB%8C-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%DB%8C%D8%B1%D8%AC%D9%86%D8%AF-',
      icon: 'la-calendar',
    },
    {
      id: 16,
      title: 'کتابخانه مرکزی',
      link: 'https://birjand.ac.ir/lib/fa',
      icon: 'la-book-reader',
    },
    {
      id: 17,
      title: 'اتوماسیون تغذیه',
      link: 'http://selfservice.birjand.ac.ir/',
      icon: 'la-utensils',
    },
    {
      id: 18,
      title: 'سامانه 111',
      link: 'https://portal.111.ir/',
      icon: 'la-user-circle',
    },
    {
      id: 19,
      title: 'تلویزیون اینترنتی',
      link: 'https://tv.birjand.ac.ir/',
      icon: 'la-tv',
    },
  ]
  const renderConnected = () => {
    return (
      <div className='text-center'>
        <div className='row justify-content-center'>
          {connectedServices
            .filter((item) => item?.title.includes(keyword))
            .map((item) => (
              <CardItem item={item} />
            ))}
        </div>
      </div>
    )
  }
  const renderProf = () => {
    return (
      <div className='text-center'>
        <div className='row justify-content-center'>
          {profServices
            .filter((item) => item?.title.includes(keyword))
            .map((item) => (
              <CardItem item={item} />
            ))}
        </div>
      </div>
    )
  }
  const renderStu = () => {
    return (
      <div className='text-center'>
        <div className='row justify-content-center'>
          {stuServices
            .filter((item) => item?.title.includes(keyword))
            .map((item) => (
              <CardItem item={item} />
            ))}
        </div>
      </div>
    )
  }
  const renderOtherStu = () => {
    return (
      <div className='text-center'>
        <div className='row justify-content-center'>
          {otherStuServices
            .filter((item) => item?.title.includes(keyword))
            .map((item) => (
              <CardItem item={item} />
            ))}
        </div>
      </div>
    )
  }
  const renderParent = () => {
    return (
      <div className='text-center'>
        <div className='row justify-content-center'>
          {parentServices
            .filter((item) => item?.title.includes(keyword))
            .map((item) => (
              <CardItem item={item} />
            ))}
        </div>
      </div>
    )
  }
  const renderStaff = () => {
    return (
      <div className='text-center'>
        <div className='row justify-content-center'>
          {staffServices
            .filter((item) => item?.title.includes(keyword))
            .map((item) => (
              <CardItem item={item} />
            ))}
        </div>
      </div>
    )
  }
  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return renderConnected()
      case 1:
        return renderProf()
      case 2:
        return renderStu()
      case 3:
        return renderOtherStu()
      case 4:
        return renderParent()
      case 5:
        return renderStaff()
      default:
        return renderConnected()
    }
  }
  const handleChangeKeyword = (e: any) => {
    setKeyword(e.target.value)
  }

  return (
    <>
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className='container'>
        <div className='row justify-content-center my-2'>
          <div className='col-md-6 col-xs-12'>
            <TextField
              label='جستجو'
              margin='dense'
              autoFocus
              size='small'
              placeholder='جستجوی خدمت'
              name='keyword'
              onChange={handleChangeKeyword}
              fullWidth
              value={keyword}
            />
          </div>
        </div>
        {renderContent()}
      </div>
    </>
  )
}

export {DashboardWrapper}
